import styles from './Messagepanel.module.css'

export type MessagepanelProps = {
  title?: string
  subtitle?: string
  footer?: string
  asset?: React.ReactNode
}

export const PhnxMessagepanel: React.FC<MessagepanelProps> = ({
  title,
  subtitle,
  footer,
  asset,
}) => {
  return (
    <div className={styles['messagepanel']}>
      {title && <div className={styles['messageTitle']}>{title}</div>}
      {subtitle && <div className={styles['messageSubtitle']}>{subtitle}</div>}
      {asset && <div className={styles['messageAsset']}>{asset}</div>}
      {footer && <div className={styles['messageFooter']}>{footer}</div>}
    </div>
  )
}
